import React, { useState, useEffect } from "react";
import { Button, Table, Image, Modal } from "react-bootstrap";
import BasicPagination from "../../../Pagination/Pagination";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";

import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import AddOpenIssuesVendor from "../superAdminOpenIssuesVendor/InsideAllPageComponent/AddOpenIssuesVendor";
//import EditOpenIssuesVendor from "../superAdminOpenIssuesVendor/InsideAllPageComponent/EditOpenIssuesVendor";
import {
  getallSuggestions,
  changeSuggestionStatus,
} from "../../../../store/actions/SuperAdminActions/commonSuperAdmin";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

const SuperAdminSuggestion = (props) => {
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);

  const pageChangeButtonHandler = (value) => {
    setSelectedTab(value);
  };

  const onSuccessChangeStatus = () => {
    onCloseModal();
    const token = props.auth.user.accessToken;
    props.getallSuggestions(
      token,
      selectedTab,
      skip,
      onSuccessSuggestions,
      onErrorSuggestions
    );
  };
  const onErrorChangeStatus = () => {
    onCloseModal();
  };
  const [suggId, setSugId] = useState();

  const onSubmitHandler = (e) => {
    const token = props.auth.user.accessToken;
    const formData = {};
    formData.status = currentStatus;
    props.changeSuggestionStatus(
      token,
      formData,
      suggId,
      onSuccessChangeStatus,
      onErrorChangeStatus
    );
  };
  const [page, setPage] = useState(1);
  const [skip, setSkip] = useState(0);
  const handleBatchChange = (pageNo) => {
    var calcSkip = (pageNo - 1) * 10;
    setSkip(calcSkip);
    setPage(pageNo);
  };

  const onSuccessSuggestions = () => {
    setLoading(false);
  };
  const onErrorSuggestions = () => {
    setLoading(false);
  };

  const appendSuggestionNew = () => {
    const token = props.auth.user.accessToken;
    props.getallSuggestions(
      token,
      selectedTab,
      skip,
      onSuccessSuggestions,
      onErrorSuggestions
    );
  };

  useEffect(() => {
    setLoading(true);
    const token = props.auth.user.accessToken;
    props.getallSuggestions(
      token,
      selectedTab,
      skip,
      onSuccessSuggestions,
      onErrorSuggestions
    );
  }, [skip]);

  useEffect(() => {
    setPage(1);
    setSkip(0);
    setLoading(true);
    const token = props.auth.user.accessToken;
    props.getallSuggestions(
      token,
      selectedTab,
      0,
      onSuccessSuggestions,
      onErrorSuggestions
    );
  }, [selectedTab]);

  const [modalStatus, setModalStatus] = useState(false);
  const onCloseModal = () => {
    setModalStatus(false);
  };

  const [currentStatus, setCurrentStatus] = useState(0);
  const statusTypes = [
    { name: "New", status: 0 },
    { name: "In-Progress", status: 1 },
    { name: "Uploaded", status: 2 },
    { name: "Communicated", status: 3 },
    { name: "Re-Opened", status: 4 },
    { name: "Resolved", status: 5 },
  ];
  const onShowModal = (status, suggestionId) => {
    setCurrentStatus(status);
    setSugId(suggestionId);
    setModalStatus(true);
  };

  const onChangeTempStatus = (status) => {
    setCurrentStatus(status);
  };

  const calcStatus = (status) => {
    if (status === 0) {
      return "New";
    } else if (status === 1) {
      return "In-Progress";
    } else if (status === 2) {
      return "Uploaded";
    } else if (status === 3) {
      return "Communicated";
    } else if (status === 4) {
      return "Re-Opened";
    } else if (status === 5) {
      return "Resolved";
    }
  };

  return (
    <React.Fragment>
      {!loading ? (
        <>
          <div className="container-fluid">
            <div className="row">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
              <div className="super-admin-right-side-panel">
                <HomeReusableTopBarNavigation />
                <div className="super-admin-inside-right-side-panel">
                  <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                    <div className="f24_700_HelveticaNeue">All Suggestions</div>
                    <AddOpenIssuesVendor
                      appendSuggestionNew={appendSuggestionNew}
                    />
                  </div>
                  <div className="row align-items-center justify-content-between">
                    <div className="col-md-6 d-flex align-items-center">
                      <Button
                        variant="link"
                        className={`px-0 mr-4 text-grayLink f12-500 ${
                          selectedTab === 0 ? "active" : ""
                        }`}
                        onClick={(e) => pageChangeButtonHandler(0)}
                      >
                        New
                      </Button>
                      <Button
                        variant="link"
                        className={`px-0 mr-4 text-grayLink f12-500 ${
                          selectedTab === 1 ? "active" : ""
                        }`}
                        onClick={(e) => pageChangeButtonHandler(1)}
                      >
                        In-Progress
                      </Button>
                      <Button
                        variant="link"
                        className={`px-0 mr-4 text-grayLink f12-500 ${
                          selectedTab === 5 ? "active" : ""
                        }`}
                        onClick={(e) => pageChangeButtonHandler(5)}
                      >
                        Resolved
                      </Button>
                      <Button
                        variant="link"
                        className={`px-0 mr-4 text-grayLink f12-500 ${
                          selectedTab === 3 ? "active" : ""
                        }`}
                        onClick={(e) => pageChangeButtonHandler(3)}
                      >
                        All
                      </Button>
                    </div>
                    <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                      <Table className="enOpenTicketsUsers HideShowTable">
                        <thead>
                          <tr className="super_admin_all_users_table_head">
                            <th className="f12-700" style={{ width: "10%" }}>
                              Sr. No
                            </th>
                            <th className="f12-700" style={{ width: "15%" }}>
                              Restaurant Name
                            </th>
                            <th className="f12-700" style={{ width: "15%" }}>
                              Suggestion Title
                            </th>
                            <th className="f12-700" style={{ width: "15%" }}>
                              Category Name
                            </th>
                            <th className="f12-700" style={{ width: "30%" }}>
                              Description
                            </th>
                            <th className="f12-700" style={{ width: "15%" }}>
                              Status
                            </th>
                            {/* <th className="f12-700" style={{ width: "7%" }}>
                          Action
                        </th> */}
                          </tr>
                        </thead>
                        {props.allSuggestions &&
                          // props.allSuggestions.data &&
                          props.allSuggestions.map((suggestion, index) => (
                            <tbody key={index}>
                              <tr className="super_admin_all_users_table_body super-admin-suggestion-table-body">
                                <td style={{ width: "10%" }}>
                                  <div className="f12-400 text-break">
                                    {suggestion._id}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="super-admin-suggestion-table-body-boxone">
                                    <div className="super-admin-suggestion-imageBox mr-3">
                                      <Image
                                        fluid
                                        //src={require("../../../../assets/images/superadmin/macd.png")}
                                        src={
                                          suggestion &&
                                          suggestion.restaurant_id &&
                                          suggestion.restaurant_id.logo_url
                                        }
                                        alt="Restaurant logo"
                                      />
                                    </div>
                                    <div className="super-admin-suggestion-imageBoxText pl-0">
                                      <div className="f12-400">
                                        {suggestion &&
                                          suggestion.restaurant_id &&
                                          suggestion.restaurant_id
                                            .restaurant_name}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="f12-400">
                                    {suggestion && suggestion.issue_title}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="f12-400">
                                    {" "}
                                    {suggestion &&
                                      suggestion.categoryId &&
                                      suggestion.categoryId.category_name}
                                  </div>
                                </td>
                                <td style={{ width: "30%" }}>
                                  <div className="f12-400">
                                    {suggestion && suggestion.comment}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="f12-400">
                                      {calcStatus(suggestion.status)}
                                    </div>
                                    <i
                                      className="ml-2 fa fa-angle-down"
                                      aria-hidden="true"
                                      onClick={() =>
                                        onShowModal(
                                          suggestion.status,
                                          suggestion._id
                                        )
                                      }
                                    ></i>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          ))}
                      </Table>
                    </div>
                    {props.allSuggestions &&
                    // props.allSuggestions.data &&
                    props.allSuggestions.length !== 0 ? (
                      <BasicPagination
                        totalRecords={
                          props.allSuggestions && props.allSuggestions.total
                        }
                        limit={10}
                        batch={page}
                        onBatchChange={(e) => handleBatchChange(e)}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <AmealioLoader />
      )}
      <Modal
        show={modalStatus}
        backdrop="static"
        keyboard={false}
        centered
        className="enStatusListModal"
        size="sm"
        onHide={onCloseModal}
      >
        <Modal.Header className="border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">
            Suggestion
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="pb-4 f16-500">
            Select one relevant option from below
          </div>
          <ul type="none" className="enStatusList">
            {statusTypes.map((status, index) => (
              <li
                onClick={() => onChangeTempStatus(status.status)}
                key={index}
                className={`${currentStatus === status.status ? "active" : ""}`}
              >
                {status.name}
              </li>
            ))}
          </ul>
          <div className="py-4 d-flex align-items-center">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5 btn150px"
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={() => onSubmitHandler()}
              className={`btn-lg px-5 btn150px `}
            >
              Confirm
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

SuperAdminSuggestion.propTypes = {
  auth: PropTypes.object.isRequired,
  getallSuggestions: PropTypes.func.isRequired,
  changeSuggestionStatus: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allSuggestions: state.commonSuperAdmin.allSuggestions,
});

export default connect(mapStateToProps, {
  getallSuggestions,
  changeSuggestionStatus,
})(SuperAdminSuggestion);
